import {
	createFileRoute,
	Outlet,
	redirect,
	useLocation,
} from "@tanstack/react-router";
import { AnimatePresence, motion } from "motion/react";
import { getPreferredPartnerId } from "@/lib/auth/token";

export const Route = createFileRoute("/flex/dashboard")({
	beforeLoad: async ({ context, location }) => {
		const { partner, partners, hasMultiplePartners } = context;
		const preferredPartner = getPreferredPartnerId();

		// Allow access to select page without partner selection
		if (location.pathname === "/flex/dashboard/select") {
			return;
		}

		// If multiple partners and no selection, redirect to select
		if (hasMultiplePartners && !preferredPartner) {
			// Extract the path after /flex/dashboard/, but handle edge cases
			const pathAfterDashboard = location.pathname.replace(
				/^\/flex\/dashboard\/?/,
				"",
			);
			// Only pass next if it's a valid sub-path (not empty, not "dashboard")
			const next =
				pathAfterDashboard && pathAfterDashboard !== "dashboard"
					? pathAfterDashboard
					: "";
			const action = (location.search as { action?: string })?.action;
			throw redirect({
				to: "/flex/dashboard/select",
				search: { next, action },
			});
		}

		// If no partners at all, redirect to root (will show access denied)
		if (partners.length === 0) {
			throw redirect({
				to: "/",
			});
		}

		// If single partner but no partner object (shouldn't happen), redirect
		if (!partner && partners.length === 1) {
			throw redirect({
				to: "/",
			});
		}
	},
	component: DashboardLayout,
});

function DashboardLayout() {
	const location = useLocation();
	return (
		<AnimatePresence mode="popLayout" initial={false}>
			<motion.div
				key={location.pathname}
				initial={{ opacity: 0, y: 6 }}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: -6 }}
				transition={{ duration: 0.18, ease: [0.32, 0.72, 0, 1] }}
				className="flex h-full w-full flex-col"
			>
				<Outlet />
			</motion.div>
		</AnimatePresence>
	);
}
